/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".h-cl-12[_ngcontent-%COMP%]   .h-gr[_ngcontent-%COMP%]{-ms-flex-direction:row-reverse;flex-direction:row-reverse}\n/*# sourceMappingURL=auth-issue-date.component.css.map*/"];
export { styles as styles };
